// Angular
import { Directive, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { defer, finalize, Observable, Subject, takeUntil } from 'rxjs';

// Helpers
import { UtilityHelper } from '../helpers';

// Environment
import { environment } from '../../../environments/environment';

@Directive()
export abstract class AppCleanup implements OnInit, OnDestroy {
	isProcessing: boolean = false;
	apiUrl: string = environment.apiUrl;
	lvHubUrl: string = environment.lvHubUrl;
	syncApiUrl: string = environment.syncApiUrl;
	deviceHubUrl: string = environment.hubUrl;
	jobHubUrl: string = `${this.apiUrl}JobHub`;
	isPortal: boolean = !environment.viewer && !environment.edge;
	isViewer: boolean = environment.viewer;
	isEdge: boolean = environment.edge;
	isOnline: boolean = navigator.onLine;

	protected readonly destroy = new Subject<void>();

	ngOnInit() {}

	ngOnDestroy() {
		this.destroy.next();
		this.destroy.complete();
	}

	trackByFunction(index, item) {
		return UtilityHelper.trackByFunction(index, item);
	}
}
